import { request } from "@/lib/api";

export function getFreeExtras() {
  return request("/api/me/free-extras", { forceFresh: true });
}

export function saveFreeExtras(enabled) {
  return request("/api/me/free-extras", {
    method: "PATCH",
    body: JSON.stringify({ enabled }),
  });
}
